import mergeToNew from "@insite/client-framework/Common/mergeToNew";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import translate from "@insite/client-framework/Translate";
import Typography, { TypographyPresentationProps } from "@insite/mobius/Typography";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import React, { FC } from "react";
import { css } from "styled-components";

export interface CheckoutCartLinesListHeaderStyles {
    wrapper?: InjectableCss;
    productCountText?: TypographyPresentationProps;
}

export const cartLinesListHeaderStyles: CheckoutCartLinesListHeaderStyles = {
    wrapper: {
        css: css`
            display: flex;
            justify-content: space-between;
            padding-bottom: 10px;
        `,
    },
    productCountText: { weight: 600, size: 14, color: "#3a3a3a" },
};

const CheckoutCartLinesListHeader: FC<{
    productsCount: number;
    isCondensed: boolean;
    hideCondensedSelector?: boolean;
    onChangeIsCondensed?: (event: React.SyntheticEvent, value: boolean) => void;
    extendedStyles?: CheckoutCartLinesListHeaderStyles;
}> = ({ productsCount, extendedStyles }) => {
    const [styles] = React.useState(() => mergeToNew(cartLinesListHeaderStyles, extendedStyles));

    const productsLabel = productsCount > 1 ? "Items" : "Item";

    return (
        <StyledWrapper {...styles.wrapper}>
            <Typography {...styles.productCountText}>
                {productsCount} {translate(productsLabel)}
            </Typography>
        </StyledWrapper>
    );
};

export default CheckoutCartLinesListHeader;
